<!--  -->
<template>
  <div>
    服务商
  </div>
</template>

<script>
import { getList } from '@/api/providerAccountManagement/servicePorviderList'
export default {
  components: {},
  data() {
    return {
      query: {
        page: 1,
        page_size: 10
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      this.list()
    },
    async list() {
      const data = await getList(this.query)
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
